import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import "./section-tag.m.css";

const SectionName = ({ story }) => {
  const sections = get(story, ["sections", "0"], {});
  return (
    <Link href={sections["section-url"]}>
      <div styleName="section">{sections["display-Name"] || sections.name}</div>
    </Link>
  );
};

export { SectionName };

SectionName.propTypes = {
  story: PropTypes.object
};
